export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 计划管理-需求计划-我的需求计划
  {
    path: 'myDemanPlanList',
    name: 'myDemanPlanList',
    meta: {
      title: '我的需求计划',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['myDemanPlanList']
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/myDemanPlan/myDemanPlanList');
    }
  }, // 计划管理-需求计划-我的需求计划-新增需求
  {
    path: 'myDemanAdd',
    name: 'myDemanAdd',
    meta: {
      title: '新增需求',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/myDemanPlan/myDemanAdd/myDemanAdd');
    }
  }, // 计划管理-需求计划-我的需求计划-新增需求-新增明细
  {
    path: 'materielDetailAdd',
    name: 'materielDetailAdd',
    meta: {
      title: '新增明细',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/myDemanPlan/myDemanAdd/materielDetailAdd');
    }
  }, // 计划管理-需求计划-我的需求计划-新增需求-修改明细
  {
    path: 'materielDetailEdit',
    name: 'materielDetailEdit',
    meta: {
      title: '修改明细',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/myDemanPlan/myDemanAdd/materielDetailEdit');
    }
  }, // 计划管理-需求计划-我的需求计划-需求详情
  {
    path: 'myDemanPlanDetail',
    name: 'myDemanPlanDetail',
    meta: {
      title: '需求计划详情',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/myDemanPlan/myDemanPlanDetail');
    }
  }, // 计划管理-需求汇总-需求计划
  {
    path: 'summaryDemanList',
    name: 'summaryDemanList',
    meta: {
      title: '需求汇总',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['summaryDemanList']
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/summaryDeman/summaryDemanList');
    }
  }, // 计划管理-需求计划-需求汇总-汇总操作-需求汇总单
  {
    path: 'summaryDemanOperate',
    name: 'summaryDemanOperate',
    meta: {
      title: '汇总需求计划',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/summaryDeman/summaryDemanOperate');
    }
  }, // 计划管理-需求计划-需求汇总-汇总操作-汇总计划详情
  {
    path: 'summaryDemanDetail',
    name: 'summaryDemanDetail',
    meta: {
      title: '汇总计划详情',
      menuTab: ''
    },
    component: function component() {
      return import('@/pages/planModule/demandPlanMenu/summaryDeman/summaryDemanDetail');
    }
  }, // 计划管理-采购计划管理-采购计划提报
  {
    path: 'purchasePlanSubmitManage',
    name: 'purchasePlanSubmitManage',
    meta: {
      title: '采购计划提报',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['purchasePlanSubmitManage']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanSubmitManage/purchasePlanSubmitManage');
    }
  }, // 计划管理-采购计划管理-采购计划提报-选择需求明细物料
  {
    path: 'chooseDemanDetailMateri',
    name: 'chooseDemanDetailMateri',
    mate: {
      title: '选择需求明细物料',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanSubmitManage/chooseDemanDetailMateri');
    }
  }, //  计划管理-采购计划管理-采购计划提报-需求生成计划
  {
    path: 'needsMakePlan',
    name: 'needsMakePlan',
    meta: {
      title: '需求生成计划',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanSubmitManage/needsMakePlan');
    }
  }, // 计划管理-采购计划管理-采购计划提报-需求详情
  {
    path: 'needsDetailPlan',
    name: 'needsDetailPlan',
    meta: {
      title: '需求详情',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanSubmitManage/needsDetailPlan');
    }
  }, // 计划管理-采购计划管理-采购计划提报-新增计划
  {
    path: 'addPlan',
    name: 'addPlan',
    meta: {
      title: '新增计划',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanSubmitManage/addPlan');
    }
  }, // 计划管理-采购计划管理-采购计划提报-计划详情
  {
    path: 'planDetail',
    name: 'planDetail',
    meta: {
      title: '计划详情',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanSubmitManage/planDetail');
    }
  }, // 计划管理-采购计划管理-集采计划审批
  {
    path: 'centraPurchasePlanApproval',
    name: 'centraPurchasePlanApproval',
    meta: {
      title: '集采计划审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['centraPurchasePlanApproval']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/centraPurchasePlanApproval/centraPurchasePlanApproval');
    }
  }, // 计划管理-采购计划管理-集采计划审批-操作详情
  {
    path: 'centraPurchasePlanApprovalAction',
    name: 'centraPurchasePlanApprovalAction',
    meta: {
      title: '集采计划审批-操作详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/centraPurchasePlanApproval/centraPurchasePlanApprovalAction');
    }
  }, // 计划管理-采购计划管理-集采计划审批-详情
  {
    path: 'centraPurchasePlanApprovalDetail',
    name: 'centraPurchasePlanApprovalDetail',
    meta: {
      title: '集采计划审批-详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/centraPurchasePlanApproval/centraPurchasePlanApprovalDetail');
    }
  }, // 计划管理-采购计划管理-集采计划分配
  {
    path: 'centraPurchasePlanDistribut',
    name: 'centraPurchasePlanDistribut',
    meta: {
      title: '集采计划分配',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['centraPurchasePlanDistribut']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/centraPurchasePlanDistribut/centraPurchasePlanDistribut');
    }
  }, // 计划管理-采购计划管理-集采计划分配-二级分配
  {
    path: 'centraPurchasePlanDistributeSecond',
    name: 'centraPurchasePlanDistributeSecond',
    meta: {
      title: '集采计划分配-二级分配',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['centraPurchasePlanDistributeSecond']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/centraPurchasePlanDistribut/centraPurchasePlanDistributeSecond');
    }
  }, // 计划管理-采购计划管理-集采计划分配-快捷分配
  {
    path: 'centraPurchasePlanDistributFast',
    name: 'centraPurchasePlanDistributFast',
    meta: {
      title: '集采计划分配-快捷分配',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/centraPurchasePlanDistribut/centraPurchasePlanDistributFast');
    }
  }, // 计划管理-采购计划管理-自采计划审批
  {
    path: 'selfPurchasePlanApproval',
    name: 'selfPurchasePlanApproval',
    meta: {
      title: '自采计划审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['selfPurchasePlanApproval']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/selfPurchasePlanApproval/selfPurchasePlanApproval');
    }
  }, // 计划管理-采购计划管理-自采计划审批-操作详情
  {
    path: 'selfPurchasePlanApprovalAction',
    name: 'selfPurchasePlanApprovalAction',
    meta: {
      title: '自采计划审批-操作详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/selfPurchasePlanApproval/selfPurchasePlanApprovalAction');
    }
  }, // 计划管理-采购计划管理-自采计划审批-详情
  {
    path: 'selfPurchasePlanApprovalDetail',
    name: 'selfPurchasePlanApprovalDetail',
    meta: {
      title: '自采计划审批-详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/selfPurchasePlanApproval/selfPurchasePlanApprovalDetail');
    }
  }, // 计划管理-采购计划管理-自采计划分配
  {
    path: 'selfPurchasePlanDistribute',
    name: 'selfPurchasePlanDistribute',
    meta: {
      title: '计划分配-自采计划',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['selfPurchasePlanDistribute']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/selfPurchasePlanDistribute/selfPurchasePlanDistribute');
    }
  }, // 计划管理-采购计划管理-自采计划分配-二级分配
  {
    path: 'selfPurchasePlanDistributeSecond',
    name: 'selfPurchasePlanDistributeSecond',
    meta: {
      title: '自采计划分配-二级分配',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['selfPurchasePlanDistributeSecond']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/selfPurchasePlanDistribute/selfPurchasePlanDistributeSecond');
    }
  }, // 计划管理-采购计划管理-自采计划分配-快捷分配
  {
    path: 'selfPurchasePlanDistributeFast',
    name: 'selfPurchasePlanDistributeFast',
    meta: {
      title: '自采计划分配-快捷分配',
      cache: 'true',
      hidden: true
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/selfPurchasePlanDistribute/selfPurchasePlanDistributeFast');
    }
  }, // 计划管理-采购计划管理-采购计划执行
  {
    path: 'purchasePlanAction',
    name: 'purchasePlanAction',
    meta: {
      title: '采购计划执行',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['purchasePlanAction']
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanAction/purchasePlanAction');
    }
  }, // 计划管理-采购计划管理-采购计划执行-匹配商品
  {
    path: 'purchasePlanMachCommodity',
    name: 'purchasePlanMachCommodity',
    meta: {
      title: '采购计划执行-匹配商品',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/purchasePlanMenu/purchasePlanAction/purchasePlanMachCommodity');
    }
  }, // 计划管理-计划管理设置-计划分配设置
  {
    path: 'planDistributeConfig',
    name: 'planDistributeConfig',
    meta: {
      title: '计划分配设置',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['planDistributeConfig']
    },
    component: function component() {
      return import('@/pages/planModule/planManageConfigMenu/planDistributeConfig/planDistributeConfig');
    }
  }, // 计划管理-计划管理设置-计划分配设置-新增
  {
    path: 'addPlanDistributeSetting',
    name: 'addPlanDistributeSetting',
    meta: {
      title: '计划分配设置-新增',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/planManageConfigMenu/planDistributeConfig/addPlanDistributeSetting');
    }
  }, // 计划管理-计划管理设置-快捷分配规则设置
  {
    path: 'planDistributeFastConfig',
    name: 'planDistributeFastConfig',
    meta: {
      title: '快捷分配规则设置',
      cache: 'true',
      isCheckMenu: true,
      belongMenus: ['planDistributeFastConfig']
    },
    component: function component() {
      return import('@/pages/planModule/planManageConfigMenu/planDistributeFastConfig/planDistributeFastConfig');
    }
  }, // 计划管理-计划管理设置-快捷分配规则设置-新增
  {
    path: 'addPlanDistributeFastConfigAdd',
    name: 'addPlanDistributeFastConfigAdd',
    meta: {
      title: '快捷分配规则设置-新增',
      hidden: 'true'
    },
    component: function component() {
      return import('@/pages/planModule/planManageConfigMenu/planDistributeFastConfig/addPlanDistributeFastConfigAdd');
    }
  }]
};